import api from '../token';

export const DeleteUnidade = async (dados) => {
  try {
    const response = await api.post('/deleteUnidade', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};